import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=523ecba0&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"
import style0 from "./Heading.vue?vue&type=style&index=0&id=523ecba0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ecba0",
  null
  
)

export default component.exports